import React, { Component } from "react";
import { Table, Button, Modal, Col, Row, message, Tooltip, Select } from "antd";
import axios from "axios";
import "./Pages.css";
import PedidoFiltroForm from '../components/PedidoFiltroForm';
import OrdemServicoServicosPrintModal from "../relatorios/OrdemServicoServicosPrintModal";
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from '../utils/Colors';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Option } = Select;


export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalOS: 0,
    qtdeOS: 0,
    formFiltroVisivel: false,

    filtros: {
      tipoTela: 'OSSERV',
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaPessoa: { key: '0', },
      buscaProduto: { key: '0', },
      buscaGrupoProduto: { key: '0', },
      buscaMarcaProduto: { key: '0', },
      buscaServico: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaSitFin: { key: 'X', },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, totalOS: 0, qtdeOS: 0 });
    const { pagina, limite } = this.state;
    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario,
      buscaSitFin, buscaServico } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/ordem_servicos/servicosOS', {
        params: {
          page: pagina,
          limite: limite,
          numero: buscaControle,
          pessoa: buscaPessoa.key,
          usuario: buscaUsuario.key,
          servico: buscaServico.key,
          sitFin: String(buscaSitFin.key),
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          totalOS: response.data.totalOS,
          qtdeOS: response.data.qtdeOS,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };




  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(this.state.filtros.buscaControle),
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaSitFin: this.state.filtros.buscaSitFin,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };




  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderSitOS = (sit, registro) => {
    const os_situacao = { key: sit }
    return (
      <span> {sit === 'ESP' ? 'ESPERA' : (sit === 'AGE' ? 'ABERTO' : (sit === 'EXE' ? 'EXECUÇÃO' : (sit === 'FIN' ? 'FINALIZADA' : (sit === 'ENT' ? 'ENTREGUE' : ''))))} </span>
    );
  };


  renderValor = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      filtros, formFiltroVisivel, total, pagina, limite } = this.state;

    // console.log('OrdemServicoServicosPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Relatório dos Serviços Executados</span>
        <div className="divider-page1" />

        <div className="pageFiltro" style={{ height: 50 }}>
          <Col xs={24} >
            <Col xs={11}>
              <Col xs={2} style={{ width: 110 }}>
                <Button
                  type="primary"
                  onClick={this.onAbrirFiltroClick}
                  className="botao-primary"
                  style={{ marginRight: 15 }}
                >
                  Filtrar
                </Button>
              </Col>

              <Col xs={2} style={{ width: 110 }}>
                <OrdemServicoServicosPrintModal
                  filtros={filtros}
                  totalOS={this.state.totalOS}
                  qtdeOS={this.state.qtdeOS}
                />
              </Col>

              <PedidoFiltroForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />
            </Col>

            <Col xs={24} md={8} style={{ height: 65, padding: 5, marginTop: -25 }}>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Qtde Serviços
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.state.qtdeOS}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Valor Total
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalOS)}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
            </Col>

            {/* <Col xs={24} sm={11} style={{ background: Colors.background, padding: 5, marginTop: -10 }}>
              <Col xs={24} sm={11} style={{ marginRight: 5, textAlign: "center", background: "white", marginLeft: 5 }} >
                <Row><span style={{ fontWeight: "bold" }}>Qtde Serviços</span></Row>
                <Row><span>{this.state.qtdeOS}</span></Row>
              </Col>
              <Col xs={24} sm={12} style={{ marginRight: 0, textAlign: "center", background: "white" }} >
                <Row><span style={{ fontWeight: "bold" }}>Valor Total</span></Row>
                <Row><span>R$ {this.renderValor(this.state.totalOS)}</span></Row>
              </Col>
            </Col> */}
          </Col>

        </div>



        <div style={{ paddingTop: 0 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.os_idf)}
          >
            <Column
              key="os_numero"
              dataIndex="os_numero"
              title="Número"
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="os_data_emissao"
              dataIndex="os_data_emissao"
              title="Data"
              render={this.renderData}
              width={120}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title="Cliente"
              width={200}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="os_descricao"
              dataIndex="os_descricao"
              title="Descrição"
              width={150}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="os_situacao"
              dataIndex="os_situacao"
              title="Situação"
              render={this.renderSitOS}
              width={90}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="serv_descricao"
              dataIndex="serv_descricao"
              title="Serviço"
              width={100}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="osis_qtde"
              dataIndex="osis_qtde"
              title="Qtde"
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="osis_vlr_unit"
              dataIndex="osis_vlr_unit"
              title="Valor Unit"
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="osis_vlr_total"
              dataIndex="osis_vlr_total"
              title="Valor Serviço"
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/OrdemServicoServicosPage.js